import { Component, OnInit } from '@angular/core';
import { serviceURLService } from '../service/serviceURL';
import { Router } from '@angular/router';
import * as $ from 'jquery';
declare var $: any;

@Component({
  selector: 'app-check-in',
  templateUrl: './check-in.component.html',
  styleUrls: ['./check-in.component.css']
})
export class CheckInComponent implements OnInit {
  data: any = {};
  error: any;
  lat: any;
  lng: any;
  _id: any;
  userID: any;
  checkInDetails: any;
  updatedTime: any;
  leaveCountNotifications: any;
  TeamMemberCountNotifications: any;
  supervisorCheck: boolean;
  loginAttempts: any;
  wrongloginAttempt: any;
  teamCheckInCount: any;
  teamCheckOutCount: any;
  successCheckInCount: any;
  failureCheckInCount: any;
  successCheckOutCount: any;
  failureCheckOutCount: any;
  teamSuccessCheckInCount: any;
  teamSuccessCheckOutCount: any;
  teamSuccessLeaveCount: any;
  successMessageCheckIn: any;
  successMessageCheckOut: any;
  locationParam: { "latitude": number; "longitude": number; };
  loading: boolean = false;
  locationErrorMessage: string;

  constructor(private serviceURLService: serviceURLService, private router: Router) {
    this.userID = localStorage.getItem('userID');
    this.supervisorCheck = JSON.parse(localStorage.getItem('isSupervisor'));
  }

  ngOnInit() {
  //this.leaveCount();
    this.UpdatedleaveCount();
  //this.teamMemberCount();
  //this.UpdatedteamInputOutCount();
  //this.teamInputOutCount();
    this.countDetailsInOut();
  //this.getLocation();
    
  }

  public getLocation(location) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(pos => {

        var lng = +pos.coords.longitude;
        var lat = +pos.coords.latitude;
        var locationParam = {
          "latitude": lat,
          "longitude": lng,
        }
        if (location)
          location(locationParam);
        //let location = new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude);
      });
      // ,function (error) {
      //   console.log("Testing Error "+error);
      //   if (error.code == error.PERMISSION_DENIED)
      //     console.log("Please enable Location Service in your device..")
      // });

      // navigator.geolocation.watchPosition(function (pos) {
      //   console.log("i'm tracking you!", pos);
      // },function (error) {
      //   if (error.code == error.PERMISSION_DENIED)
      //     alert("Please enable Location Service in your device..");
      // });
      // console.log("outisde ",this.lng, this.lat)
    }
  }

  checkIn() {
    this.loading = true;
    this.successMessageCheckIn = '';
    this.successMessageCheckOut = '';
    this.error = '';
    this.getLocation(res => {
      this.data = {
        "latitude": res.latitude,
        "longitude": res.longitude,
        "isCheckInFromWeb": 'false'
      }
      const timer = setTimeout(() => {
        this.loading = false;
        this.successMessageCheckIn = 'Internal server error';
        $('#checkInModal').modal('show');
      }, 30000);
      this.serviceURLService.checkIn(this.data, this.userID).subscribe((successData: any) => {
        console.log("check in data ", this.data)
        this.successMessageCheckIn = successData.message;
        console.log("Checked-in successfully");
        clearTimeout(timer);
        this.loading = false;
        $('#checkInModal').modal('show');
      }, errorData => {
        if (errorData.error.status === 401) {
          this.router.navigate(['/login']);
        } else if (errorData.error.status === 403 || errorData.error.status === 400) {
          this.error = errorData.error.message;
        }
        clearTimeout(timer);
        this.loading = false;
        $('#checkInModal').modal('show');
      })
    });
  }
  checkOut() {
    this.loading = true;
    this.successMessageCheckIn = '';
    this.successMessageCheckOut = '';
    this.error = '';
    this.getLocation(res => {
      this.data = {
        "latitude": res.latitude,
        "longitude": res.longitude,
        "isCheckOutFromWeb": 'false'
      }
      const timer = setTimeout(() => {
        this.loading = false;
        this.successMessageCheckOut = 'Internal server error';
        $('#checkInModal').modal('show');
      }, 30000);
      this.serviceURLService.checkOut(this.data, this.userID).subscribe((successData: any) => {
        console.log("Checked-out successfully");
        this.successMessageCheckOut = successData.message;
        clearTimeout(timer);
        this.loading = false;
        $('#checkInModal').modal('show');
      }, errorData => {
        if (errorData.error.status === 401) {
          this.router.navigate(['/login']);
        } else if (errorData.error.status === 403 || errorData.error.status === 400) {
          this.error = errorData.error.message;
        }
        clearTimeout(timer);
        this.loading = false;
        $('#checkInModal').modal('show');
      })
    });
  }
  leaveCount() {
    this.data = {
      "updatedTime": null,

    }
    this.serviceURLService.getLeaveCount(this.data, this.userID).subscribe((successData: any) => {
      this.leaveCountNotifications = successData.response.leavesLeftForUser;
      this.loginAttempts = successData.response.user.loginAttemps;
      this.wrongloginAttempt = successData.response.user.lastWrongLoginAttemptTime;
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        console.log("ERROR: ", this.error);
      }
    })
  }
//---------start------------updated leave count -----------
  UpdatedleaveCount() {
    this.data = {
      "updatedTime": null,

    }
    this.serviceURLService.getUpdatedLeaveCount(this.data, this.userID).subscribe((successData: any) => {
      this.leaveCountNotifications = successData.response.leavesLeftForUser;
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        console.log("ERROR: ", this.error);
      }
    })
  }
// ----updated leave countend-------------------

  teamMemberCount() {
    this.data = {
      "updatedTime": null,

    }

    this.serviceURLService.getTeamCount(this.data, this.userID).subscribe((successData: any) => {
      this.TeamMemberCountNotifications = successData.response.user.teamMembers.length;
      this.supervisorCheck = successData.response.user.isSupervisor;
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        console.log("ERROR: ", this.error);
      }
    })
  }

  countDetailsInOut() {
   // this.loading = true;
    this.serviceURLService.getInOutCount(this.userID).subscribe((successData: any) => {
      this.successCheckInCount = successData.response.checkIn.success;
      this.failureCheckInCount = successData.response.checkIn.late;
      this.successCheckOutCount = successData.response.checkOut.success;
      this.failureCheckOutCount = successData.response.checkOut.late;
      this.teamSuccessCheckInCount = successData.response.team.checkIn.pending;
      this.teamSuccessCheckOutCount = successData.response.team.checkOut.pending;
      this.teamSuccessLeaveCount = successData.response.team.leave.pending;
      this.loading = false;
    }, errorData => {
      this.loading = false;
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        console.log("ERROR: ", this.error);
      }
    })
  }

  teamInputOutCount() {
    this.data = {
      "updatedTime": null,
    }
    this.serviceURLService.getTeam(this.data, this.userID).subscribe((successData: any) => {
      this.teamCheckInCount = successData.response.pendingRequests.pendingCheckInData.length;
      this.teamCheckOutCount = successData.response.pendingRequests.pendingCheckOutData.length;
      this.loading = false;
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        console.log("ERROR: ", this.error);
      }
    })
  }

  UpdatedteamInputOutCount() {
    this.data = {
      "updatedTime": null,

    }
    this.serviceURLService.getUpdatedTeam(this.data, this.userID).subscribe((successData: any) => {
      this.teamCheckInCount = successData.response.pendingRequests.pendingCheckInData.length;
      this.teamCheckOutCount = successData.response.pendingRequests.pendingCheckOutData.length;
      this.loading = false;
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        console.log("ERROR: ", this.error);
      }
    })
  }

  showCheckOutConfirmation() {
    $('#checkOutConfirmModal').modal('show');
  }

  confirmCheckOut() {
    $('#checkOutConfirmModal').modal('hide');
    this.checkLoggedin('checkOut');
  }

  checkLoggedin(type) {
    this.loading = true;
    if (!navigator.geolocation) {
      this.locationErrorMessage = "Geolocation is not supported by this browser.";
      $('#localtionEnableModal').modal('show');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const { latitude, longitude } = pos.coords;
        this.locationParam = { latitude, longitude };
        if(latitude && longitude){
          if (type === 'checkIn') {
            this.checkIn();
          } else if (type === 'checkOut') {
            this.checkOut();
          }
        }else{
          this.locationErrorMessage = "We can't detect your location. Please enable location access.";
          $('#checkInModal').modal('show');
          this.loading = false;
        }

      },
      (error) => {
        console.log("Geolocation error:", error.message);
        switch (error.code) {
        case error.PERMISSION_DENIED:
          this.locationErrorMessage = "We can't detect your location because permission is blocked. Please enable location access in your browser or try on laptop/desktop.";
          $('#checkInModal').modal('show');
          this.loading = false;
          break;
        case error.POSITION_UNAVAILABLE:
          this.locationErrorMessage = "We’re unable to find your location at the moment. Please try again later.";
          $('#checkInModal').modal('show');
          this.loading = false;
          break;
        case error.TIMEOUT:
          this.locationErrorMessage = "It took too long to get your location. Make sure your GPS is on and that you have an active internet connection, then try again.";
          $('#checkInModal').modal('show');
          this.loading = false;
          break;
        default:
          this.locationErrorMessage = "An unknown error occurred. Please try again.\n" + error.message;
          console.error("unknown geolocation error:", error.message);
          $('#checkInModal').modal('show');
          this.loading = false;
      }
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 }
    );
  }
}
